/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { ButtonSanityLink } from 'sarsaparilla';

import type { SearchResultItem } from '../../api/search/search.types';
import { CardStarRating } from './CardStarRating';
import { CardPrice } from './CardPrice';

import styles from './CardFooter.module.scss';

interface CardFooterProps {
    item: SearchResultItem;
}

export function CardFooter({ item }: CardFooterProps) {
    if (item.park_pass_facility_id) {
        return (
            <div className={cx(styles.footer, styles.hasPass)}>
                <ButtonSanityLink
                    appearance="soft-brand"
                    size="sm"
                    href={`/sitepass/${item.park_pass_facility_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Buy a Pass for ${item.name}`}
                >
                    Buy a Pass
                </ButtonSanityLink>
            </div>
        );
    }

    // if there's no rating or price, return null
    if (!item.average_rating && !item.price_range) {
        return <div className={styles.emptyFooter} />;
    }

    return (
        <div className={styles.footer}>
            <CardStarRating item={item} />
            <CardPrice item={item} className={styles.price} />
        </div>
    );
}

// cSpell:ignore sitepass
